
export const TranslationHtmlDirective = {
    bind(el: HTMLElement, binding: any) {
        el.innerHTML = binding.value instanceof Array ? binding.value.join("") : binding.value;
    },
};
